export enum GeofenceStatus {
    PENDING = "PENDING",
    VERIFIED = "VERIFIED",
    STAGING = "STAGING"
}